import { Route, Routes } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PageNotFound from '../pages/ErrorPage/PageNotFound';
import DashboardLayout from '../layouts/DashboardLayout';
import RiderSetting from '../pages/Rider/RiderSetting';
import { MerchantSetting } from '../pages/Merchant/MerchantSetting';
import BranchSetting from '../pages/Branch/BranchSetting';
import RunsheetEdit from '../pages/Runsheet/EditRunsheetStatus';
import ManifestStatusEdit from '../pages/Manifest/EditManifestStatus';
import PickupStatusEdit from '../pages/Pickup Request/EditPickupRequestStatus';
import Delivery from '../pages/Deliverey/Delivery';
import RTVStatusEdit from '../pages/RTV/Return/EditRTVStatus';
import RTVBranchStatusEdit from '../pages/RTVBranch/EditRTVBranch';
import OverviewSetting from '../pages/Overview/OverviewSetting';
import { getKey } from '../helpers/sessionKey';
//@ts-ignore
import { WelcomeRouterService } from '@careinfo/welcome-page-service';
import Website from '../pages/WebSite';
import VehicleManifestStatusEdit from '../pages/VehicleManifest';
import PickDropEdit from '../pages/PickDrop';

const Router = () => {
  const shouldShowWelcome = getKey('shouldShowWelcome');
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route
          path={'/project-settings'}
          element={
            shouldShowWelcome === 'true' || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <OverviewSetting />
            )
          }
        />
        <Route
          path={'/project-settings/overview'}
          element={<OverviewSetting />}
        />
        <Route
          path={'/project-settings/rider-settings'}
          element={<RiderSetting />}
        />
        <Route
          path={'/project-settings/merchant-settings'}
          element={<MerchantSetting />}
        />
        <Route
          path={'/project-settings/branch-settings'}
          element={<BranchSetting />}
        />

        <Route
          path='/project-settings/runsheet-edit-status'
          element={<RunsheetEdit />}
        />
        <Route
          path='/project-settings/manifest-edit-status'
          element={<ManifestStatusEdit />}
        />
        <Route
          path='/project-settings/pickuprequest-edit-status'
          element={<PickupStatusEdit />}
        />
        <Route
          path='/project-settings/delivery-edit-status'
          element={<Delivery />}
        />
        <Route
          path='/project-settings/vehicle-edit-status'
          element={<VehicleManifestStatusEdit />}
        />
        <Route
          path='/project-settings/pick&drop-edit-status'
          element={<PickDropEdit />}
        />
        <Route path='/project-settings/website' element={<Website />} />
        <Route
          path='/project-settings/rtv-edit-status'
          element={<RTVStatusEdit />}
        />
        <Route
          path='/project-settings/rtv-edit-branch-status'
          element={<RTVBranchStatusEdit />}
        />

        <Route path='/*' element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
